import type { ReactNode } from 'react';
import { CustomerAuthProvider, useCustomerAuth } from '../portal/CustomerAuthContext';
import { revokeStoredNotificationDevice } from './lib/notificationsApi';

export function DestekAuthProvider({ children }: { children: ReactNode }) {
  return (
    <CustomerAuthProvider beforeSignOut={revokeStoredNotificationDevice}>
      {children}
    </CustomerAuthProvider>
  );
}

export const useDestekAuth = useCustomerAuth;
